module.exports = __webpack_public_path__ + "img/web.eb4fecdb.gif";